import { Component, DestroyRef, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Store } from '@ngrx/store';

import {
  BreadcrumbItem,
  ContentTitleImagePipe,
  HasTitleImagePipe,
  IOffersState,
  OfferDetailsBaseComponent,
} from '@resident-nx/shared';
import { filter } from 'rxjs';
import { ROUTE } from '../../../models';
import { DateTransformPipe } from '../../../pipes/date.pipe';
import { TranslateModule } from '@ngx-translate/core';
import { AsyncPipe } from '@angular/common';
import { LoaderWebComponent, ImageWebComponent } from '@resident-nx/web/ui';
import { BreadcrumbsWebComponent } from '../../atoms/breadcrumbs/breadcrumbs.component';
import { CardWebComponent, Elevation } from '@resident-nx/web/ui';
import { ImmomioButtonComponent } from '@immomio/ui/button';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ImageBorderRadiusEnum } from '@resident-nx/web/util';

@Component({
  standalone: true,
  selector: 'rs-web-offer-details',
  templateUrl: './offer-details.component.html',
  styleUrls: ['./offer-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    BreadcrumbsWebComponent,
    ImageWebComponent,
    ImmomioButtonComponent,
    LoaderWebComponent,
    AsyncPipe,
    TranslateModule,
    DateTransformPipe,
    CardWebComponent,
    ContentTitleImagePipe,
    HasTitleImagePipe,
  ],
})
export class OfferDetailsWebComponent extends OfferDetailsBaseComponent implements OnInit {
  #destroyRef = inject(DestroyRef);
  public readonly Elevation = Elevation;
  public readonly ImageBorderRadiusEnum = ImageBorderRadiusEnum;
  public breadcrumbs: BreadcrumbItem[] = [
    {
      label: 'main_navigation_news_l',
      url: ROUTE.NEWS,
    },
    {
      label: 'news.offers_l',
      url: `${ROUTE.NEWS}/${ROUTE.OFFERS}`,
    },
  ];

  constructor(
    private store: Store<IOffersState>,
    private route: ActivatedRoute,
    private router: Router
  ) {
    super(store);
  }

  ngOnInit(): void {
    this.offer$
      .pipe(
        filter(o => o !== null),
        takeUntilDestroyed(this.#destroyRef)
      )
      .subscribe(offer => {
        this.breadcrumbs.push({ label: offer.title });
      });
  }

  public onNavigateBack() {
    this.router.navigate([ROUTE.NEWS, ROUTE.OFFERS]);
  }

  public onNavigate(event: string) {
    this.router.navigate([event]);
  }
}
